// extracted by mini-css-extract-plugin
export var footer = "_qj-0";
export var inherit = "_qj-1";
export var input = "_qj-2";
export var modalContent = "_qj-3";
export var quillEditor = "_qj-4";
export var subtitle = "_qj-5";